// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d85f1c3b","455":"0b26d872","977":"fefc5420"}[chunkId] + ".chunk.js";
};